import headerApi from "./headerApi";
import newBfdHeaderApi from './newBfdHeaderApi';
import showOrder from "./showOrder";
import home from "./home";
export default {
  headerApi,
  newBfdHeaderApi,
  showOrder,
  home
};
